import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 15000 },
    markReadUrl: String
  }

  connect() {
    this.paused = false
    this.onMouseEnter = () => this.pauseDismiss()
    this.onMouseLeave = () => this.resumeDismiss()
    this.element.addEventListener("mouseenter", this.onMouseEnter)
    this.element.addEventListener("mouseleave", this.onMouseLeave)
    this.scheduleDismiss()
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    this.element.removeEventListener("mouseenter", this.onMouseEnter)
    this.element.removeEventListener("mouseleave", this.onMouseLeave)
  }

  scheduleDismiss() {
    window.clearTimeout(this.timeout)
    if (this.paused) return
    this.timeout = window.setTimeout(() => this.dismiss(), this.delayValue)
  }

  pauseDismiss() {
    this.paused = true
    window.clearTimeout(this.timeout)
  }

  resumeDismiss() {
    this.paused = false
    this.scheduleDismiss()
  }

  dismiss() {
    window.clearTimeout(this.timeout)
    this.element.classList.add("notification-toast--leaving")
    window.setTimeout(() => this.element.remove(), 280)
  }

  async markRead(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = this.markReadUrlValue
    if (!url) return

    const token = document.querySelector('meta[name="csrf-token"]')?.content ?? ""
    try {
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "X-CSRF-Token": token,
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })
      if (response.ok) this.dismiss()
    } catch {
      // Garde le toast ouvert pour réessayer.
    }
  }
}
